import {inject, ref} from 'vue';

export default {
    install: (app, options) => {
        const appConfig = ref({
            date_year: document.body.getAttribute('data-date-year'),
            guest_main_url: document.body.getAttribute('data-app-main-url'),
            user_profile_logged_in: false,
            user_profile_logged_out: false,
        });

        app.provide('appConfig', appConfig);
    },
}
